import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class ContactAlias extends BaseEntityModel {
  id?: number;
  contactId?: number;
  extractedContactId?: number;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  isPrimary?: boolean;

  constructor(model: Partial<ContactAlias> = {}) {
    super(model);

    this.id = model.id;
    this.contactId = model.contactId;
    this.extractedContactId = model.extractedContactId;
    this.firstName = model.firstName;
    this.middleName = model.middleName;
    this.lastName = model.lastName;
    this.isPrimary = model.isPrimary;
  }

  get fullName(): string | null {
    return !!this.firstName || !!this.lastName
      ? [this.firstName, this.middleName, this.lastName].filter(Boolean).join(' ')
      : null;
  }
}
